if (!customElements.get('vn-sticky-atc')) {
  customElements.define(
    'vn-sticky-atc',
    class VnStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.button = this.querySelector('.vn-sticky-atc__button');
        this.buttonLabel = this.button.querySelector('span');
        this.priceTarget = this.querySelector('.vn-sticky-atc__price');
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.button.addEventListener('click', this.onClick.bind(this));
        this.bind();
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => requestAnimationFrame(() => this.bind()));
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.unsubscribe?.();
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          const rect = this.submit?.getBoundingClientRect();
          this.toggleAttribute('data-visible', Boolean(rect) && rect.bottom < 0);
        });
      }

      get submit() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      bind() {
        if (!this.submit) return;
        this.sync();
        this.onScroll();
      }

      sync() {
        const submit = this.submit;
        const price = document.querySelector(`#price-${this.sectionId} .price`);
        if (price) {
          const clone = price.cloneNode(true);
          clone.querySelectorAll('.badge, .price__badge-sale, .price__badge-sold-out').forEach((badge) => badge.remove());
          this.priceTarget.replaceChildren(clone);
        }
        if (submit) {
          const label = submit.querySelector('span')?.textContent.trim();
          if (label) this.buttonLabel.textContent = label;
          this.button.disabled = submit.disabled;
        }
      }

      onClick() {
        const submit = this.submit;
        if (!submit) return;
        if (submit.disabled) {
          submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        submit.click();
      }
    }
  );
}
